export const RakovoData = [
    {
        title: "дом №5",
        year: '1984',
        floor: "2",
        apartment: "22",
        quantityLC: "22",
        livingArea: "945,6",
        notLivinigArea: "85,5",
        commonProperty: "",
        type: "многоэтажный дом",
        level: "ХВС, ГВС, отопление, канализация, электроснабжение",
        technicalSupport: "нет",
        contractURL: 'rakovo/sofrino_rakovo_5_dogovor.pdf',
        prilozhenyaURL: 'rakovo/sofrino_rakovo_5_prilozheniya.pdf',
        passportURL: 'rakovo/sofrino_rakovo_5_passport.zip',
    }
]
